//HELPERS
import { getTranslatedString } from 'helpers/i18n';

const ERROR_TRANSLATIONS = {
  required: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.required');
  },
  previousStartDate: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.previousStartDate');
  },
  previousEndDate: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.previousEndDate');
  },
  inValidPhoneNumber: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.phoneNumber');
  },
  inValidEmail: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.email');
  },
  terms: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.terms');
  },
  instructionsTerms: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.instructionsTerms');
  },
  inValidSin: function () {
    return getTranslatedString('tenantPortal.tenantApplication.error.sinNumber');
  },

  cotenant: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.cotenant.required');
    },
    dupEmail: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.cotenant.dupEmail');
    },
  },

  occupant: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.occupant.required');
    },
  },

  vehicle: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.vehicle.required');
    },
  },

  pet: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.pet.required');
    },
  },
  emergencyContact: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.emergencyContact.required');
    },
  },
  landlordReference: {
    required: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.landlordReference.required');
    },
    dupEmail: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.landlordReference.dupEmail');
    },
  },
  personalReference: {
    dupEmail: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.personalReference.dupEmail');
    },
    fullName: function () {
      return getTranslatedString('tenantPortal.tenantApplication.error.personalReference.fullName');
    },
  },
};

export default ERROR_TRANSLATIONS;
